module.exports = __webpack_public_path__ + "media/bootstrap-icons/slash-square-15620361.svg";